var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMov = function SvgMov(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "MOV",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\uD83D\\uDD04",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-177.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-9",
    transform: "translate(33.000000, 455.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "MOV",
    transform: "translate(177.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5435696,23.6347846 C21.5435696,24.9145378 20.5143323,25.9519044 19.2446988,25.9519044 L3.43987467,25.9519044 C2.17024118,25.9519044 1.14100393,24.9144872 1.14100393,23.6347846 L1.14100393,2.31711984 C1.14100393,1.03741724 2.17024118,2.03487588e-15 3.43987467,2.03487588e-15 L13.2789069,2.03487588e-15 C13.7368141,2.03487588e-15 14.1759513,0.183589449 14.4993571,0.51031987 L21.0398917,7.11690428 C21.3624443,7.44267164 21.5435696,7.88415814 21.5435696,8.34439895 L21.5435696,23.6347846 Z",
    id: "Path",
    fill: "#F9F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99070654,25.9519044 L3.43967393,25.9519044 C2.17039174,25.9519044 1.14100393,24.9143351 1.14100393,23.6345311 L1.14100393,2.31737328 C1.14100393,1.0375693 2.17039174,2.03487588e-15 3.43967393,2.03487588e-15 L4.99070654,2.03487588e-15 C3.72142436,2.03487588e-15 2.69203655,1.0375693 2.69203655,2.31737328 L2.69203655,23.6344804 C2.69203655,24.9143351 3.72142436,25.9519044 4.99070654,25.9519044 Z",
    id: "Path",
    fill: "#E3E0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5435696,8.34429757 L21.5435696,9.19229632 L15.5482175,9.19229632 C13.8358333,9.19229632 12.4429904,7.78506444 12.4429904,6.05561332 L12.4429904,-1.01743794e-15 L13.2790073,-1.01743794e-15 C13.7365632,-1.01743794e-15 14.1760517,0.183792198 14.4991563,0.510167808 L21.0399419,7.11670153 C21.3625949,7.44251958 21.5435696,7.88425952 21.5435696,8.34429757 L21.5435696,8.34429757 Z",
    id: "Path",
    fill: "#E3E0E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3889933,7.62580491 L15.5482175,7.62580491 C14.6899677,7.62580491 13.9940732,6.92297462 13.9940732,6.05561332 L13.9940732,0.157181358 C14.1807191,0.242285357 14.3518571,0.361349856 14.4992065,0.510167808 L21.0399921,7.11670153 C21.1873415,7.2654688 21.3047291,7.43780566 21.3889933,7.62580491 Z",
    id: "Path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5968901,22.5055726 L2.08768338,22.5055726 C0.945525143,22.5055726 0.0196231598,21.5703917 0.0196231598,20.4169005 L0.0196231598,12.7931737 C0.0196231598,11.6396319 0.94557533,10.7045016 2.08768338,10.7045016 L20.5969403,10.7045016 C21.7390985,10.7045016 22.6650005,11.6396826 22.6650005,12.7931737 L22.6650005,20.4168498 C22.6650005,21.5704423 21.7390484,22.5055726 20.5968901,22.5055726 L20.5968901,22.5055726 Z",
    id: "Path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3802022,22.5055726 L2.08768338,22.5055726 C0.94557533,22.5055726 0.0196231598,21.570341 0.0196231598,20.4169005 L0.0196231598,12.7931737 C0.0196231598,11.6396826 0.945625518,10.7045016 2.08768338,10.7045016 L3.38025239,10.7045016 C2.23814434,10.7045016 1.31219217,11.6397332 1.31219217,12.7931737 L1.31219217,20.4168498 C1.31214198,21.570341 2.23809415,22.5055726 3.3802022,22.5055726 L3.3802022,22.5055726 Z",
    id: "Path",
    fill: "#286EC1"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MOV",
    fontFamily: "HelveticaNeue, Helvetica Neue",
    fontSize: 7.44827586,
    letterSpacing: 0.744827566,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.31034483,
    y: 19.4137931
  }, "MOV"))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMov);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mov.67bf4a2b19ce1af6e2138c2bf49b87bc.svg";